export default "__VITE_ASSET__d0f5f598__"